// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/fonts/Nunito/Nunito.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case_flow_audit {
  font-size: 12px !important;
  font-family: montserrat !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 62vh;
}

.labcase_flow_audit {
  font-family: Nunito, sans-serif !important;
}

.audit-loader,
.audit-empty {
  min-height: 62vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-size: 12px;
}

.audit-empty--inline {
  min-height: 0;
  flex: 1;
}

::ng-deep .audit-info-spinner circle {
  stroke: #376b96 !important;
}

::ng-deep .audit-info-spinner .mdc-circular-progress__indeterminate-circle-graphic {
  stroke: #376b96 !important;
}

.audit-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 8px 10px;
  align-items: flex-end;
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
}

.audit-filters__field {
  min-width: 0;
  flex: 1 1 100px;
}

.audit-filters__label {
  display: block;
  font-weight: 600;
  color: #376b96;
  margin-bottom: 2px;
  font-size: 11px;
}

.audit-filters__select {
  font-size: 12px;
  font-family: inherit;
  height: 30px;
  width: 100%;
  max-width: none;
}

.audit-split {
  display: flex;
  align-items: stretch;
  height: 68vh;
  width: 100%;
  min-height: 0;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  background: #fff;
  overflow: hidden;
}

.audit-split__left {
  flex: 0 0 50%;
  width: 50%;
  max-width: 50%;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e6e6e6;
  background: #fff;
}

.audit-split__detail {
  flex: 1 1 50%;
  width: 50%;
  min-width: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: #f7fbfd;
}

.audit-timeline-viewport {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  background: #fff;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.audit-pin-stack {
  position: sticky;
  top: 0;
  z-index: 400;
  height: 0;
  overflow: visible;
  pointer-events: none;
  background: transparent;
}

.audit-virtual-row {
  margin: 0;
  padding: 0;
  min-height: 35px;
  height: auto;
  padding-bottom: 2px;
}

.audit-date-section {
  background: #fff;
  margin: 0;
  padding: 0;
  position: relative;
  z-index: 1;
}

.audit-date-header {
  width: 100%;
  height: 35px;
  min-height: 35px;
  max-height: 35px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  margin: 0;
  background: #17a0b4;
  padding: 0 12px;
  cursor: pointer;
  text-align: left;
  color: #fff;
  position: relative;
  flex-shrink: 0;
  z-index: 2;
}

.audit-date-header--pinned {
  position: relative;
  top: auto;
  z-index: 401;
  pointer-events: auto;
  width: 100%;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
}

/* Keep layout space when header is shown in the pin stack */
.audit-date-header--spacer {
  visibility: hidden;
  pointer-events: none;
}

.audit-date-header:hover {
  background: #17a0b4;
  color: #fff;
}

.audit-date-header__calendar {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #fff;
  flex-shrink: 0;
}

.audit-date-header__title {
  font-weight: 700;
  font-size: 12px;
  flex: 1;
  color: #fff;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audit-date-header__meta {
  font-size: 10px;
  color: #fff;
  font-weight: 500;
  opacity: 0.95;
  flex-shrink: 0;
}

.audit-date-header__chevron {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}

.audit-event__columns {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  min-height: 28px;
  max-height: 28px;
  box-sizing: border-box;
  padding: 0 10px;
  margin: 0;
  background: #eef3f6;
  border-bottom: 1px solid #dce4ea;
  position: sticky;
  /* top set inline from pinStackHeight */
  z-index: 300;
  font-size: 10px;
  font-weight: 700;
  color: #305e83;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.audit-event__columns--collapsed {
  display: none;
}

.audit-date-body {
  margin: 0;
  border: 1px solid #d9e2e8;
  border-top: 0;
  border-radius: 0;
  background: #f8fafb;
  padding: 0;
  opacity: 1;
  position: relative;
  z-index: 1;
  transition: max-height 0.4s ease, min-height 0.4s ease, opacity 0.35s ease, border-width 0.35s ease;
}

.audit-date-body--collapsed {
  max-height: 0 !important;
  min-height: 0 !important;
  opacity: 0;
  overflow: hidden;
  border-width: 0;
  pointer-events: none;
}

.audit-event {
  border-bottom: 1px solid #c5d0d8;
  background: #fff;
}

.audit-event--expanded {
  background: #f0f7fa;
  border: 1px solid #17a0b4;
  box-shadow: inset 0 0 0 1px rgba(23, 160, 180, 0.12);
}

.audit-event--expanded .audit-event__row {
  border-bottom: 0;
  background: #e8f5f8;
}

.audit-event__row {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  border: 0;
  border-left: 2px solid transparent;
  background: transparent;
  padding: 8px 10px;
  text-align: left;
  cursor: pointer;
  min-height: 40px;
}

.audit-event__row--failed {
  border-left-color: #dc3545;
}

.audit-event__row:hover {
  background: #f5f8fb;
}

.audit-event__col {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.audit-event__col--time {
  flex: 0 0 52px;
  width: 52px;
}

.audit-event__col--action {
  flex: 1 1 0;
  min-width: 0;
}

.audit-event__col--interface {
  flex: 1 1 0;
  min-width: 0;
}

.audit-event__col--actor {
  flex: 0 0 88px;
  width: 88px;
}

.audit-event__col--type {
  flex: 0 0 72px;
  width: 72px;
}

.audit-event__field-label {
  display: none;
}

.audit-event__field-value {
  font-size: 12px;
  color: #222;
  word-break: break-word;
}

.audit-event__col--time .audit-event__field-value {
  font-weight: 700;
  color: #376b96;
}

.audit-event__col--action .audit-event__field-value {
  font-weight: 600;
}

.audit-event__col--interface .audit-event__field-value {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.audit-event__type {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 2px;
  font-weight: 600;
  font-size: 10px;
  background: #e9ecef;
  color: #495057;
  width: -moz-fit-content;
  width: fit-content;
}

.audit-event__type--interface {
  background: #e8f1f8;
  color: #376b96;
}

.audit-event__type--cases {
  background: #fff3e0;
  color: #c46a00;
}

.audit-event__expand-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #376b96;
  flex-shrink: 0;
}

.audit-event__detail {
  padding: 10px 12px 12px;
  min-height: 100%;
  box-sizing: border-box;
}

.audit-detail-empty {
  min-height: 100%;
  padding: 16px 12px;
  color: #6c757d;
  font-size: 12px;
}

.audit-detail-block {
  margin-bottom: 10px;
}

.audit-detail-block__title {
  font-weight: 700;
  color: #376b96;
  margin-bottom: 4px;
  font-size: 11px;
}

.audit-detail-text {
  color: #444;
  white-space: pre-wrap;
  word-break: break-word;
  background: #f5f5f5;
  padding: 8px;
  border-radius: 2px;
}

.audit-kv-card {
  background: #f5f5f5;
  overflow: hidden;
  border-radius: 2px;
}

.audit-kv-row {
  display: flex;
  min-height: 32px;
  width: 100%;
  border-bottom: 1px solid #e1dddd;
  padding: 6px 1px;
  gap: 10px;
  align-items: flex-start;
}

.audit-kv-row:last-child {
  border-bottom: 0;
}

.audit-kv-key {
  flex: 0 0 20%;
  width: 20%;
  max-width: 20%;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audit-kv-value {
  flex: 1;
  min-width: 0;
  text-align: left;
  word-break: break-word;
  cursor: pointer;
  color: #333;
}

.audit-kv-value:hover {
  color: #376b96;
}

.audit-helpers {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.audit-helpers__group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.audit-helper-link {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  border: 0;
  background: #eef6fb;
  color: #305e83;
  text-align: left;
  padding: 6px 8px;
  border-radius: 2px;
  cursor: pointer;
  font-size: 11px;
}

.audit-helper-link:hover {
  background: #ddebf5;
}

.audit-helper-link__icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  margin-top: 1px;
}

.audit-helper-link__text {
  word-break: break-all;
}

.audit-helper-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  align-self: flex-start;
  border: 1px solid #c5d6e4;
  background: #fff;
  color: #305e83;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.audit-helper-chip:hover {
  background: #f0f6fb;
}

.audit-helper-chip__icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
}

@media (max-width: 768px) {
  .audit-split {
    flex-direction: column;
    height: auto;
    max-height: none;
  }
  .audit-split__left {
    flex: none;
    width: 100%;
    max-width: 100%;
    height: 50vh;
    border-right: 0;
    border-bottom: 1px solid #e6e6e6;
  }
  .audit-split__detail {
    flex: none;
    width: 100%;
    height: 40vh;
  }
  .audit-event__columns {
    display: none;
  }
  .audit-event__row {
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .audit-event__col {
    flex: 1 1 45%;
    width: auto;
  }
  .audit-event__col--action {
    flex: 1 1 100%;
  }
  .audit-event__field-label {
    display: block;
    font-size: 9px;
    font-weight: 700;
    color: #6c757d;
    text-transform: uppercase;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/case360/caseaudit/caseaudit.component.scss"],"names":[],"mappings":"AAGA;EACE,0BAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AADF;;AAIA;EACE,0CAAA;AADF;;AAIA;;EAEE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,OAAA;AADF;;AAIA;EACE,0BAAA;AADF;;AAIA;EACE,0BAAA;AADF;;AAIA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;AADF;;AAIA;EACE,YAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;AADF;;AAIA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,uCAAA;AADF;;AAIA,4DAAA;AACA;EACE,kBAAA;EACA,oBAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAAA;AADF;;AAIA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,SAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,mGAAA;AADF;;AAKA;EACE,wBAAA;EACA,wBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAFF;;AAKA;EACE,gCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,yBAAA;EACA,oDAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAFF;;AAKA;EACE,cAAA;EACA,WAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,cAAA;EACA,WAAA;AAFF;;AAKA;EACE,cAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,sBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EAAA,kBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,uBAAA;EACA,gBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,gBAAA;EACA,WAAA;EACA,gCAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAKA;EACE;IACE,sBAAA;IACA,YAAA;IACA,gBAAA;EAFF;EAKA;IACE,UAAA;IACA,WAAA;IACA,eAAA;IACA,YAAA;IACA,eAAA;IACA,gCAAA;EAHF;EAMA;IACE,UAAA;IACA,WAAA;IACA,YAAA;EAJF;EAOA;IACE,aAAA;EALF;EAQA;IACE,eAAA;IACA,uBAAA;EANF;EASA;IACE,aAAA;IACA,WAAA;EAPF;EAUA;IACE,cAAA;EARF;EAWA;IACE,cAAA;IACA,cAAA;IACA,gBAAA;IACA,cAAA;IACA,yBAAA;EATF;AACF","sourcesContent":["@import '../../../variables.scss';\r\n@import 'src/assets/fonts/Nunito/Nunito.css';\r\n\r\n.case_flow_audit {\r\n  font-size: 12px !important;\r\n  font-family: montserrat !important;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 62vh;\r\n}\r\n\r\n.labcase_flow_audit {\r\n  font-family: Nunito, sans-serif !important;\r\n}\r\n\r\n.audit-loader,\r\n.audit-empty {\r\n  min-height: 62vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #6c757d;\r\n  font-size: 12px;\r\n}\r\n\r\n.audit-empty--inline {\r\n  min-height: 0;\r\n  flex: 1;\r\n}\r\n\r\n::ng-deep .audit-info-spinner circle {\r\n  stroke: #376b96 !important;\r\n}\r\n\r\n::ng-deep .audit-info-spinner .mdc-circular-progress__indeterminate-circle-graphic {\r\n  stroke: #376b96 !important;\r\n}\r\n\r\n.audit-filters {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  padding: 8px 8px 10px;\r\n  align-items: flex-end;\r\n  flex-shrink: 0;\r\n  background: #fff;\r\n  border-bottom: 1px solid #e6e6e6;\r\n}\r\n\r\n.audit-filters__field {\r\n  min-width: 0;\r\n  flex: 1 1 100px;\r\n}\r\n\r\n.audit-filters__label {\r\n  display: block;\r\n  font-weight: 600;\r\n  color: #376b96;\r\n  margin-bottom: 2px;\r\n  font-size: 11px;\r\n}\r\n\r\n.audit-filters__select {\r\n  font-size: 12px;\r\n  font-family: inherit;\r\n  height: 30px;\r\n  width: 100%;\r\n  max-width: none;\r\n}\r\n\r\n.audit-split {\r\n  display: flex;\r\n  align-items: stretch;\r\n  height: 68vh;\r\n  width: 100%;\r\n  min-height: 0;\r\n  border: 1px solid #e6e6e6;\r\n  border-radius: 2px;\r\n  background: #fff;\r\n  overflow: hidden;\r\n}\r\n\r\n.audit-split__left {\r\n  flex: 0 0 50%;\r\n  width: 50%;\r\n  max-width: 50%;\r\n  min-width: 0;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-right: 1px solid #e6e6e6;\r\n  background: #fff;\r\n}\r\n\r\n.audit-split__detail {\r\n  flex: 1 1 50%;\r\n  width: 50%;\r\n  min-width: 0;\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  background: #f7fbfd;\r\n}\r\n\r\n.audit-timeline-viewport {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  width: 100%;\r\n  background: #fff;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  position: relative;\r\n}\r\n\r\n.audit-pin-stack {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 400;\r\n  height: 0;\r\n  overflow: visible;\r\n  pointer-events: none;\r\n  background: transparent;\r\n}\r\n\r\n.audit-virtual-row {\r\n  margin: 0;\r\n  padding: 0;\r\n  min-height: 35px;\r\n  height: auto;\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.audit-date-section {\r\n  background: #fff;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.audit-date-header {\r\n  width: 100%;\r\n  height: 35px;\r\n  min-height: 35px;\r\n  max-height: 35px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border: 0;\r\n  margin: 0;\r\n  background: #17a0b4;\r\n  padding: 0 12px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  color: #fff;\r\n  position: relative;\r\n  flex-shrink: 0;\r\n  z-index: 2;\r\n}\r\n\r\n.audit-date-header--pinned {\r\n  position: relative;\r\n  top: auto;\r\n  z-index: 401;\r\n  pointer-events: auto;\r\n  width: 100%;\r\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n/* Keep layout space when header is shown in the pin stack */\r\n.audit-date-header--spacer {\r\n  visibility: hidden;\r\n  pointer-events: none;\r\n}\r\n\r\n.audit-date-header:hover {\r\n  background: #17a0b4;\r\n  color: #fff;\r\n}\r\n\r\n.audit-date-header__calendar {\r\n  font-size: 16px;\r\n  width: 16px;\r\n  height: 16px;\r\n  color: #fff;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.audit-date-header__title {\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  flex: 1;\r\n  color: #fff;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.audit-date-header__meta {\r\n  font-size: 10px;\r\n  color: #fff;\r\n  font-weight: 500;\r\n  opacity: 0.95;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.audit-date-header__chevron {\r\n  font-size: 20px;\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #fff;\r\n}\r\n\r\n.audit-event__columns {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  height: 28px;\r\n  min-height: 28px;\r\n  max-height: 28px;\r\n  box-sizing: border-box;\r\n  padding: 0 10px;\r\n  margin: 0;\r\n  background: #eef3f6;\r\n  border-bottom: 1px solid #dce4ea;\r\n  position: sticky;\r\n  /* top set inline from pinStackHeight */\r\n  z-index: 300;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  color: #305e83;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.audit-event__columns--collapsed {\r\n  display: none;\r\n}\r\n\r\n.audit-date-body {\r\n  margin: 0;\r\n  border: 1px solid #d9e2e8;\r\n  border-top: 0;\r\n  border-radius: 0;\r\n  background: #f8fafb;\r\n  padding: 0;\r\n  opacity: 1;\r\n  position: relative;\r\n  z-index: 1;\r\n  transition: max-height 0.4s ease, min-height 0.4s ease, opacity 0.35s ease,\r\n    border-width 0.35s ease;\r\n}\r\n\r\n.audit-date-body--collapsed {\r\n  max-height: 0 !important;\r\n  min-height: 0 !important;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  border-width: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.audit-event {\r\n  border-bottom: 1px solid #c5d0d8;\r\n  background: #fff;\r\n}\r\n\r\n.audit-event--expanded {\r\n  background: #f0f7fa;\r\n  border: 1px solid #17a0b4;\r\n  box-shadow: inset 0 0 0 1px rgba(23, 160, 180, 0.12);\r\n}\r\n\r\n.audit-event--expanded .audit-event__row {\r\n  border-bottom: 0;\r\n  background: #e8f5f8;\r\n}\r\n\r\n.audit-event__row {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  border: 0;\r\n  border-left: 2px solid transparent;\r\n  background: transparent;\r\n  padding: 8px 10px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  min-height: 40px;\r\n}\r\n\r\n.audit-event__row--failed {\r\n  border-left-color: #dc3545;\r\n}\r\n\r\n.audit-event__row:hover {\r\n  background: #f5f8fb;\r\n}\r\n\r\n.audit-event__col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  min-width: 0;\r\n}\r\n\r\n.audit-event__col--time {\r\n  flex: 0 0 52px;\r\n  width: 52px;\r\n}\r\n\r\n.audit-event__col--action {\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n}\r\n\r\n.audit-event__col--interface {\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n}\r\n\r\n.audit-event__col--actor {\r\n  flex: 0 0 88px;\r\n  width: 88px;\r\n}\r\n\r\n.audit-event__col--type {\r\n  flex: 0 0 72px;\r\n  width: 72px;\r\n}\r\n\r\n.audit-event__field-label {\r\n  display: none;\r\n}\r\n\r\n.audit-event__field-value {\r\n  font-size: 12px;\r\n  color: #222;\r\n  word-break: break-word;\r\n}\r\n\r\n.audit-event__col--time .audit-event__field-value {\r\n  font-weight: 700;\r\n  color: #376b96;\r\n}\r\n\r\n.audit-event__col--action .audit-event__field-value {\r\n  font-weight: 600;\r\n}\r\n\r\n.audit-event__col--interface .audit-event__field-value {\r\n  overflow-wrap: anywhere;\r\n  word-break: break-word;\r\n}\r\n\r\n.audit-event__type {\r\n  display: inline-block;\r\n  padding: 1px 6px;\r\n  border-radius: 2px;\r\n  font-weight: 600;\r\n  font-size: 10px;\r\n  background: #e9ecef;\r\n  color: #495057;\r\n  width: fit-content;\r\n}\r\n\r\n.audit-event__type--interface {\r\n  background: #e8f1f8;\r\n  color: #376b96;\r\n}\r\n\r\n.audit-event__type--cases {\r\n  background: #fff3e0;\r\n  color: #c46a00;\r\n}\r\n\r\n.audit-event__expand-icon {\r\n  font-size: 18px;\r\n  width: 18px;\r\n  height: 18px;\r\n  color: #376b96;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.audit-event__detail {\r\n  padding: 10px 12px 12px;\r\n  min-height: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.audit-detail-empty {\r\n  min-height: 100%;\r\n  padding: 16px 12px;\r\n  color: #6c757d;\r\n  font-size: 12px;\r\n}\r\n\r\n.audit-detail-block {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.audit-detail-block__title {\r\n  font-weight: 700;\r\n  color: #376b96;\r\n  margin-bottom: 4px;\r\n  font-size: 11px;\r\n}\r\n\r\n.audit-detail-text {\r\n  color: #444;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n  background: #f5f5f5;\r\n  padding: 8px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.audit-kv-card {\r\n  background: #f5f5f5;\r\n  overflow: hidden;\r\n  border-radius: 2px;\r\n}\r\n\r\n.audit-kv-row {\r\n  display: flex;\r\n  min-height: 32px;\r\n  width: 100%;\r\n  border-bottom: 1px solid #e1dddd;\r\n  padding: 6px 1px;\r\n  gap: 10px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.audit-kv-row:last-child {\r\n  border-bottom: 0;\r\n}\r\n\r\n.audit-kv-key {\r\n  flex: 0 0 20%;\r\n  width: 20%;\r\n  max-width: 20%;\r\n  font-weight: 700;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.audit-kv-value {\r\n  flex: 1;\r\n  min-width: 0;\r\n  text-align: left;\r\n  word-break: break-word;\r\n  cursor: pointer;\r\n  color: #333;\r\n}\r\n\r\n.audit-kv-value:hover {\r\n  color: #376b96;\r\n}\r\n\r\n.audit-helpers {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.audit-helpers__group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.audit-helper-link {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  border: 0;\r\n  background: #eef6fb;\r\n  color: #305e83;\r\n  text-align: left;\r\n  padding: 6px 8px;\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n}\r\n\r\n.audit-helper-link:hover {\r\n  background: #ddebf5;\r\n}\r\n\r\n.audit-helper-link__icon {\r\n  font-size: 14px;\r\n  width: 14px;\r\n  height: 14px;\r\n  flex-shrink: 0;\r\n  margin-top: 1px;\r\n}\r\n\r\n.audit-helper-link__text {\r\n  word-break: break-all;\r\n}\r\n\r\n.audit-helper-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  align-self: flex-start;\r\n  border: 1px solid #c5d6e4;\r\n  background: #fff;\r\n  color: #305e83;\r\n  padding: 4px 8px;\r\n  border-radius: 12px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.audit-helper-chip:hover {\r\n  background: #f0f6fb;\r\n}\r\n\r\n.audit-helper-chip__icon {\r\n  font-size: 13px;\r\n  width: 13px;\r\n  height: 13px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .audit-split {\r\n    flex-direction: column;\r\n    height: auto;\r\n    max-height: none;\r\n  }\r\n\r\n  .audit-split__left {\r\n    flex: none;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    height: 50vh;\r\n    border-right: 0;\r\n    border-bottom: 1px solid #e6e6e6;\r\n  }\r\n\r\n  .audit-split__detail {\r\n    flex: none;\r\n    width: 100%;\r\n    height: 40vh;\r\n  }\r\n\r\n  .audit-event__columns {\r\n    display: none;\r\n  }\r\n\r\n  .audit-event__row {\r\n    flex-wrap: wrap;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .audit-event__col {\r\n    flex: 1 1 45%;\r\n    width: auto;\r\n  }\r\n\r\n  .audit-event__col--action {\r\n    flex: 1 1 100%;\r\n  }\r\n\r\n  .audit-event__field-label {\r\n    display: block;\r\n    font-size: 9px;\r\n    font-weight: 700;\r\n    color: #6c757d;\r\n    text-transform: uppercase;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
